import axios from "axios";
import { baseURl } from "../lib/config/Config";
import { ENDPOINT } from "../lib/enums/Endpoint";
import { apiContext } from "../lib/config/EncryptAPIContext";

export async function loginUser(userId: string, password: string) {
  try {
    const response = await apiContext.post(`${ENDPOINT.LOGIN}`, {
      userId,
      password,
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred during login:", error);
    throw new Error("An error occurred during login. Please try again.");
  }
}

export async function prefundBalance(userId: string, password: string) {
  try {
    const response = await axios.post(`${baseURl}${ENDPOINT.LOGIN}`, {
      userId,
      password,
    });
    return response.data.prefundInfos[0].balance;
  } catch (error) {
    console.error("Error occurred during login:", error);
    throw new Error("An error occurred during login. Please try again.");
  }
}
export const getVersion = async (): Promise<string | null> => {
  const response = await axios.get(`${baseURl}/version`);
  return response.data;
};
